module.exports = __webpack_public_path__ + "static/media/Original Korean Article from - TATHAGATA - message - jinri.30c5911f.pdf";